import React from 'react';
import testimonialImage1 from '../assets/images/Image_fx (19).jpg';
import testimonialImage2 from '../assets/images/Image_fx (94).jpg';

const Testimonials = () => {
  return (
    <section className="testimonials_wrap">
      <div className="testimonials_collection_wrap w-dyn-list">
        <div role="list" className="testimonials_collection_list w-dyn-items">
          <div role="listitem" className="testimonials_collection_item w-dyn-item">
            <div data-wf--global-eyebrow--variant="base" className="g_eyebrow u-text-small">고객님 후기</div>
            <div className="testimonials_collection_contain u-grid-custom">
              <div id="w-node-_7c4e82eb-25a0-ce34-93df-76d9c23512af-c23512a8" className="testimonials_left_wrap">
                <div data-image-reveal="" className="testimonials_left_cover">
                  <div data-image-cover="" className="g_image_cover"></div>
                  {testimonialImage1 && (
                    <img
                      src={testimonialImage1}
                      loading="lazy"
                      width="1500"
                      height="1000"
                      alt=""
                      data-image=""
                      className="testimonials_left_image"
                    />
                  )}
                </div>
                <div className="testimonials_left_message u-text-main w-richtext">
                  <p>
                    "처음 만남부터 저는 페르323 팀의 진정한 열정과, 저희가 제시한 아이디어를 기꺼이 경청하고 함께 고민하려는 모습에 깊은 인상을 받았습니다. 팀원들은 프로젝트에 대해 진심으로 애정을 갖고 접근했습니다. 디자인 과정 내내 그들은 긍정적이고 전문적이면서도, 편안한 방식으로 소통하며 의견을 경청해 주셨습니다.
                    <br />
                    <br />
                    아이디어를 모색하는 과정에서 저희의 의견과 피드백을 언제나 환영해 주셨습니다. 덕분에 페르323이 단순히 제 꿈을 실현하는 것을 넘어, 예산까지 충족시키는 결과물을 만들어 줄 것이라는 확신을 가질 수 있었습니다. 실제로 최종 결과물은 그들의 뛰어난 실력과 성과를 명확하게 증명해 주었습니다!"
                    <br />
                    <br />
                    김수현 님 (양평 자택 건축주)
                  </p>
                </div>
                <div className="testimonials_left_owner u-text-small">
                  <div className="testimonials_left_name">Design</div>
                  <div className="testimonials_left_role">페르323</div>
                </div>
              </div>
              <a data-hover-container="" id="w-node-_7c4e82eb-25a0-ce34-93df-76d9c23512b7-c23512a8" href="/project/sidney" className="testimonials_aside_wrap w-inline-block">
                <div data-image-reveal="" className="testimonials_aside_cover">
                  <div data-image-cover="" className="g_image_cover"></div>
                  <div data-hover-gradient="" className="testimonials_aside_gradient"></div>
                  <div data-hover-image="" className="testimonial_image_contain">
                    {testimonialImage2 && (
                      <img
                        src={testimonialImage2}
                        loading="lazy"
                        data-image=""
                        alt=""
                        className="testimonials_aside_image"
                      />
                    )}
                  </div>
                  <div data-hover-cover="" className="testimonials_cover_wrap">
                    <div className="testimonials_cover_name u-text-small">가평 전원주택</div>
                    {testimonialImage2 && (
                      <img
                        src={testimonialImage2}
                        loading="lazy"
                        alt=""
                        className="testimonials_cover_image"
                      />
                    )}
                    <div className="testimonials_cover_category u-text-small">올해의 주택 선정</div>
                  </div>
                </div>
                <div className="testimonials_aside_contain u-text-small">
                  <div className="testimonials_aside_details">
                    <div className="testimonials_aside_year">
                      <div className="g_deco">(</div>
                      <div className="testimonials_aside_text">2024</div>
                      <div className="g_deco">)</div>
                    </div>
                    <div className="testimonials_aside_project">가평전원주택</div>
                  </div>
                  <div className="testimonials_aside_cta">자세히보기</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;